import styled from 'styled-components';
import useStore, { actions } from '../../store/useStore';
import { RunButton } from '../Button';
import Checkbox from '../Input/Checkbox';
import Alert from '../Alert';

const DefaultComponent = styled.div``;

const RunCorrectBtn = styled(RunButton)`
    /* width: auto; */
    /* letter-spacing: inherit; */
    margin-bottom: 16px;
`;

const ButtonExplanation = styled.div`
    font-size: 0.7rem;
    letter-spacing: normal;
    font-weight: normal;
    line-height: normal;
`;

const Settings = styled.div`
    margin-bottom: 32px;
    font-size: 0.9rem;
`;

const Toolbox = ({
    component = DefaultComponent,
    hasOutput,
    // runModel,
    runElecCorrect,
    busy,
    alertText,
}) => {
    const { store, dispatch } = useStore();
    const { outputColumns, showElecCorrect } = store;

    const toggleSVO = () => {
        dispatch(actions.toggleShowStandardRecipe());
    };

    const elecCorrectClick = () => {
        dispatch(actions.toggleElecCorrect());
    };

    const Container = component;

    if (!hasOutput) {
        return null;
    }

    return (
        <Container>
            <Settings>
                <Checkbox
                    label="Toon Standaard Voedings Oplossing (SVO) en Verschill tussen Advies en SVO"
                    value={outputColumns.svo.visible}
                    onChange={toggleSVO}
                    disabled={!hasOutput}
                />
                <Checkbox
                    label="Toon handmatige correctie"
                    value={showElecCorrect}
                    onChange={elecCorrectClick}
                    disabled={!hasOutput}
                />
            </Settings>

            {showElecCorrect && (
                <RunCorrectBtn
                    disabled={busy}
                    busy={busy}
                    onClick={runElecCorrect}
                >
                    Bereken elektronische correctie{' '}
                    <ButtonExplanation>
                        (nodig om het schema ladingsneutraal te maken na
                        handmatige correctie)
                    </ButtonExplanation>
                </RunCorrectBtn>
            )}
            {/* <RunButton
                disabled={busy}
                busy={busy}
                onClick={runModel}
                variant={hasOutput && showElecCorrect ? 'secondary' : 'primary'}
            >
                {busy
                    ? 'calculating...'
                    : hasOutput
                    ? 'Advies opnieuw berekenen'
                    : 'RUN'}
            </RunButton> */}
            {alertText && <Alert>{alertText}</Alert>}
        </Container>
    );
};

export default Toolbox;
